<template>
    <div v-if="show && !show_form && !show_acess_form" class="w-[250px]  text-sm text-white rounded-lg bg-[rgba(93,93,152,0.55)]  p-4">
        <div class="flex justify-between text-white gap-2 p-2">
            <h2 class="text-[#ff9b05]">{{ title }}</h2>
            <AppButton
                v-bind:visibility="true" 
                left_icon="fa-regular fa-circle-xmark fa-xl"
                emitType="close"
                @close="close"
            />
        </div>
        <div class="p-2 flex flex-col gap-2">
            <div v-for="(value, key) in data" :key="key">
                {{ key }}: {{ value }}
                <template v-if="key === 'acesso'">
                    <span><i class="fa-solid fa-pen-to-square" style="color: #ff9b05; cursor: pointer;" @click="edit_acess"></i></span>
                </template>
                <template v-if="key === 'contatos'">
                    <span><i class="fa-regular fa-address-book" style="color: #ff9b05; cursor: pointer;" @click="show_table(key)"></i></span>
                </template>
                <template v-if="key === 'armazem'">
                    <span><i class="fa-solid fa-pen-to-square" style="color: #ff9b05; cursor: pointer;" @click="show_table(key)"></i></span>
                </template>
                <template v-if="key === 'viatura'">
                    <span><i class="fa-solid fa-pen-to-square" style="color: #ff9b05; cursor: pointer;" @click="show_table(key)"></i></span>
                </template>
                <template v-if="key === 'Adicionar_Contato'">
                    <span><i class="fa-solid fa-calendar-plus" style="color: #ff9b05; cursor: pointer;" @click="edit_acess"></i></span>
                </template>
            </div>
        </div>
        <div class="flex gap-2 p-1">
            <appButton :visibility="edit_visibility" class="text-white px-4 py-1 bg-sky-600 shadow-lg hover:bg-sky-700" text="Editar"  emitType="update" @update="update_OnClick" />
            <appButton :visibility="delete_visibility" class="text-white px-4 py-1 bg-red-700 shadow-lg hover:bg-red-800" text="Eliminar"  emitType="delete" @delete="delete_OnClick" />
        </div>
    </div>
    
    <AppForm v-if="show_form"
        :form_title="form_title" 
        v-bind:update_btn="true"
        :form_data="form_data" 
        @update_data="update" 
        @close="closeForm"
    />

    <AppForm v-if="show_acess_form"
        :form_title="second_form_title"
        v-bind:update_btn="true"
        :form_data="acess_form_data" 
        @update_data="update_acess" 
        @close="closeForm"
    />


     
</template>

<script>
    import AppButton from './button.vue'
    import AppForm from './form.vue'

    export default {
        
        name: 'AppInfoCard',
        emits: ['close','update_data', 'delete_data'],
        components: {
                AppButton,
                AppForm,
               
            },
        props: {
            data: {
                type: Object,
                default: () => ({})
            },
            
            show: {
                type: Boolean,
                default: true
            },
            form_title:{
                type: String,
                default: () =>"Atualizar Entidade"
            },
            second_form_title:{
                type: String,
                default: () =>"Editar Acesso"
            },
            title:{
                type: String,
                default: () =>"Informação da Entidade"
            },
            form_data:{
                type: Object,
                default: () => ({})
            },
            acess_form_data:{
                type: Object,
                default: () =>{}
            },
            visibility:{
                type: Boolean,
                default: () => false
            },

            edit_visibility:{
                type: Boolean,
                default: () => false
            },
            delete_visibility:{
                type: Boolean,
                default: () => false
            }
    
        },
        emits: ['close','update_data', 'delete_data', 'update_acess_data', 'show_table'],
        methods:{
            close() {
                //console.log("close button clicked")
                this.$emit('close');
            },
            update_OnClick(){
                this.show_form=true;
                this.show_acess_form=false;
     
            },

            delete_OnClick(){
               
                //console.log("to delete data:",this.data)
                this.$emit('delete_data', this.data);
                this.$emit('close');
         
            },
            update(data){
                //console.log("form_data to update:",data)
                this.$emit('update_data', data)
                
            },
            closeForm(){
                this.show_form=false;
                this.show_acess_form=false;
            },

            edit_acess(){
                console.log("acesso clicked")
                this.show_acess_form=true;
                this.show_form=false;
            },
            update_acess(data){
                this.$emit('update_acess_data',data)

            },
            show_table(data){
                console.log("show table clicked:",data)
                this.$emit('show_table',data)
            }
        },
        data() {
            return {
                show_form:false,
                show_acess_form:false,
            }
        },

        mounted() {
            
        },
        watch: {
            data: {
                handler(newValue, oldValue) {
                    console.log(oldValue)
                    console.log(newValue)
                    this.show_form=false
                    this.show_acess_form=false;  
                },
                deep: true 
            }
        }   

    
    }


</script>


<style>
    
</style>

